export function getUser() {
  const value = sessionStorage.getItem('userInfo');

  return value ? JSON.parse(value) : null;
}

export function setUser(value: any) {
  sessionStorage.setItem('userInfo', JSON.stringify(value));
}

export function removeUser() {
  sessionStorage.removeItem('userInfo');
}

export function getAccessToken() {
  const user = getUser();
  const accessToken = user && user.auth ? user.auth.accessToken : null;

  return accessToken;
}

export function getRole() {
  const user = getUser();

  return user ? user.role : '';
}

export function getUserPermissions() {
  const user = getUser();
  const privileges = user && user.privileges ? user.privileges : [];

  return privileges;
}
